(() => {
  const root = document.querySelector('[data-member-center]');
  if (!root) return;
  const requested = 'eooqi-member-return';
  const dismissed = 'eooqi-member-reminder-dismissed';
  const read = key => { try { return sessionStorage.getItem(key); } catch { return null; } };
  const write = (key, value) => { try { sessionStorage.setItem(key, value); } catch {} };
  root.querySelector('[data-member-login]')?.addEventListener('click', () => {
    write(requested, '1');
    write(dismissed, '0');
  });
  const dialog = root.querySelector('[data-member-reminder]');
  if (!dialog) return;
  if (read(requested) === '1' || read(dismissed) !== '1') {
    if (typeof dialog.showModal === 'function') dialog.showModal();
    write(requested, '0');
  }
  dialog.querySelectorAll('[data-member-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
  dialog.addEventListener('close', () => write(dismissed, '1'));
})();
